var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalogoAgricola(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4642",
    "data-name": "Rect\\xE1ngulo 4642",
    width: 85,
    height: 85,
    transform: "translate(152 6426)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "catalogo_agricola",
    "data-name": "catalogo agricola",
    transform: "translate(-152 -6426)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10062",
    "data-name": "Grupo 10062",
    transform: "translate(-476.938 5285.081)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_56",
    "data-name": "L\\xEDnea 56",
    x2: 31,
    transform: "translate(639.938 1214.838)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: "16 16 100"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_57",
    "data-name": "L\\xEDnea 57",
    x2: 25,
    transform: "translate(677.938 1214.838)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeDasharray: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19272",
    "data-name": "Trazado 19272",
    d: "M702.837,1373.964c-2.244,0-2.244-1.964-4.488-1.964s-2.244,1.964-4.487,1.964-2.244-1.964-4.487-1.964-2.244,1.964-4.488,1.964S682.643,1372,680.4,1372s-2.244,1.964-4.488,1.964-2.244-1.964-4.488-1.964-2.244,1.964-4.488,1.964S664.69,1372,662.446,1372s-2.244,1.964-4.487,1.964-2.245-1.964-4.489-1.964-2.245,1.964-4.489,1.964-2.245-1.964-4.49-1.964-2.245,1.964-4.49,1.964",
    transform: "translate(0.019 -165.999)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_58",
    "data-name": "L\\xEDnea 58",
    y1: 39,
    transform: "translate(659.938 1167.838)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19273",
    "data-name": "Trazado 19273",
    d: "M704,1191.855c0-4.338,3.927-7.855,3.927-7.855s3.927,3.517,3.927,7.855-3.927,7.855-3.927,7.855S704,1196.193,704,1191.855Z",
    transform: "translate(-48.27 -24.145)",
    fill: "#95d4e9",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19274",
    "data-name": "Trazado 19274",
    d: "M723.44,1271.763c3.791-3.791,10.3-3.432,10.3-3.432s.359,6.5-3.432,10.3-10.3,3.432-10.3,3.432S719.649,1275.554,723.44,1271.763Z",
    transform: "translate(-60.343 -87.77)",
    fill: "#95d4e9",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19275",
    "data-name": "Trazado 19275",
    d: "M659.927,1272.1c-4.332-4.332-3.922-11.767-3.922-11.767s7.434-.41,11.766,3.922,3.922,11.766,3.922,11.766S664.259,1276.431,659.927,1272.1Z",
    transform: "translate(-12.049 -81.733)",
    fill: "#95d4e9",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_59",
    "data-name": "L\\xEDnea 59",
    x1: 8.837,
    y1: 8.837,
    transform: "translate(650.829 1185.451)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_60",
    "data-name": "L\\xEDnea 60",
    x1: 6.873,
    y2: 6.873,
    transform: "translate(659.656 1187.416)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10062-2",
    "data-name": "Grupo 10062",
    transform: "translate(678.805 1191.273)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_61",
    "data-name": "L\\xEDnea 61",
    y1: 9.527,
    transform: "translate(8.342 6.182)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19276",
    "data-name": "Trazado 19276",
    d: "M834.09,1314.088c2.3-2.3,6.248-2.083,6.248-2.083s.218,3.948-2.083,6.248-6.248,2.083-6.248,2.083S831.789,1316.388,834.09,1314.088Z",
    transform: "translate(-823.659 -1312)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19277",
    "data-name": "Trazado 19277",
    d: "M800.1,1318.253c-2.3-2.3-2.083-6.248-2.083-6.248s3.948-.218,6.249,2.083,2.083,6.248,2.083,6.248S802.4,1320.554,800.1,1318.253Z",
    transform: "translate(-798.015 -1312)",
    fill: "none",
    stroke: "#0f265c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10063",
    "data-name": "Grupo 10063",
    transform: "translate(675.365 1152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19278",
    "data-name": "Trazado 19278",
    d: "M797.74,1152a8.615,8.615,0,0,1-13.734,0l-.006,0v12.687a21.867,21.867,0,0,0,13.746,20.3h0a21.867,21.867,0,0,0,13.746-20.3V1152l-.005,0a8.615,8.615,0,0,1-13.734,0Z",
    transform: "translate(-784 -1152)",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19279",
    "data-name": "Trazado 19279",
    d: "M801.5,1182.1v-5.248a12.347,12.347,0,0,0,2.577.273,12.789,12.789,0,0,0,6.873-2.047,12.789,12.789,0,0,0,6.873,2.047,12.347,12.347,0,0,0,2.577-.273v5.248a17.475,17.475,0,0,1-9.45,15.584",
    transform: "translate(-797.204 -1169.415)",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogoAgricola);
export default __webpack_public_path__ + "static/media/catalogo-agricola.1582b0e253250a005561675b7f11ffc4.svg";
export { ForwardRef as ReactComponent };